import { styled, css, Theme } from '@mui/material/styles'
import { ButtonBase } from '@mui/material'
import { ButtonProps } from './types'
import { ButtonStyles } from '../Theme/types'

const variantMap = (
  theme: Theme,
  filltype: ButtonProps['filltype'] = 'fill',
  variant: ButtonProps['variant'] = 'primary',
  parentbg: ButtonProps['parentbg'] = 'light',
  _selected?: boolean | undefined
): ButtonStyles => {
  const colorMap = theme.buttonVariantStyles
  return parentbg ? colorMap[filltype][variant][parentbg] : colorMap[filltype][variant]
}

export const buttonCss = ({
  theme,
  variant,
  filltype,
  parentbg,
  selected,
  fullwidth,
}: ButtonProps) => css({
  appearance: 'none',
  fontFamily: 'inherit',
  margin: 0,
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: theme.spacing(10),
  minWidth: theme.spacing(30),
  width: '100%',
  overflow: 'hidden',
  background: variantMap(theme, filltype, variant, parentbg, selected)?.background || 'inherit',
  color: variantMap(theme, filltype, variant, parentbg, selected)?.color || 'inherit',
  fontWeight: variantMap(theme, filltype, variant, parentbg, selected)?.fontWeight || '',
  border: `1px solid ${variantMap(theme, filltype, variant, parentbg, selected)?.borderColor || 'inherit'}`,
  verticalAlign: 'bottom',
  cursor: 'pointer',
  textDecoration: 'none',
  
  '&:disabled': {
    pointerEvents: 'none',
    background: variantMap(theme, filltype, variant, parentbg, selected)?.disabled?.background || 'inherit',
    color: variantMap(theme, filltype, variant, parentbg, selected)?.disabled?.color || 'inherit',
    fontWeight: variantMap(theme, filltype, variant, parentbg, selected)?.disabled?.fontWeight || '',
    border: `1px solid
    ${variantMap(theme, filltype, variant, parentbg, selected)?.disabled?.borderColor || 'inherit'}`,
    svg: {
      fill: variantMap(theme, filltype, variant, parentbg, selected)?.disabled?.iconFillColor || 'none',
      stroke: variantMap(theme, filltype, variant, parentbg, selected)?.disabled?.iconStrokeColor || 'inherit',
    },
  },
  '.content': {
    display: 'flex',
    alignItems: 'center',
  },
  svg: {
    fill: variantMap(theme, filltype, variant, parentbg, selected)?.iconFillColor || 'none',
    stroke: variantMap(theme, filltype, variant, parentbg, selected)?.iconStrokeColor || 'inherit',
  },
  '&:hover': {
    background: variantMap(theme, filltype, variant, parentbg, selected)?.hover?.background || 'inherit',
    color: variantMap(theme, filltype, variant, parentbg, selected)?.hover?.color || 'inherit',
    fontWeight: variantMap(theme, filltype, variant, parentbg, selected)?.hover?.fontWeight || '',
    border: `1px solid ${variantMap(theme, filltype, variant, parentbg, selected)?.hover?.borderColor || 'inherit'}`,
    svg: {
      fill: variantMap(theme, filltype, variant, parentbg, selected)?.hover?.iconFillColor || 'none',
      stroke: variantMap(theme, filltype, variant, parentbg, selected)?.hover?.iconStrokeColor || 'inherit',
    },
  },
  [theme.breakpoints.up('sm')]: {
    width: fullwidth ? '100%' : 'auto',
  },
})

export const StyledButton = styled(ButtonBase, {
  shouldForwardProp: (prop: string) => !['color', 'filltype', 'variant', 'fullwidth'].includes(prop)
})(buttonCss)
